module.exports = {
  API_URL: '//api.customers.qc.viralstyle.com',
  API_ROOT: '/api',
  APP_PROTOCOL: 'https',
  APP_URL: 'qc.viralstyle.com',
  APP_DOMAIN: 'whitelabel',
  HOME_PATH: '/',
  ENVIRONMENT: 'Staging',
  PRIMARY_COLOR: '#00B398',
  ERROR_COLOR: '#da625a',
  INFO_COLOR: '#5D9CD1',
  RAVEN_URL: 'https://af320c7effa04277bae4f97a57ad470f@sentry.io/86900',
  GOOGLE_RECAPTCHA_SITEKEY: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  GOOGLE_PLACES_API_KEY: 'AIzaSyBAPh7I-muZOUnwQAhhLmHtpyqGErfvJUI',
  PAYPAL: { ENVIRONMENT: 'sandbox', MERCHANT_ID: 'dev-paypal-merch@viralstyle.com' },
  SMARTY_STREETS: { ENABLED: false, ID: '18226769276996505' },
  GA_ID: 'UA-51001413-7',
  KEEN_PROJECT_ID: '5af59f7ac9e77c0001822469',
  KEEN_WRITE_KEY: '83954ACFB0A7EFEAEE3CA84AB9E42B4530E34FF52575B7B231B8C575F117460569DAC2849BE2B57B6C6D7456E900DB786AA7C3F8B20A1853C6CF7291712027511C53215C9A9FD7FB62C734F5514620F9956B5296714D0C10A009DBE46924AB39',
  HOLIDAY_MESSAGE: {
    endDay: 24,
    apparel: {
      message: '<small>APPAREL: If shipped to a US address your order will arrive before Dec. 24th, Happy Holidays!</small>',
      redBorder: false,
    },
    nonApparel: {
      message: '<small>NON APPAREL: If shipped to a US address your order will arrive before Dec. 24th, Happy Holidays!</small>',
      redBorder: false,
    },
    bothInCart: {
      message: '<small>BOTH: If shipped to a US address your order will arrive before Dec. 24th, Happy Holidays!</small>',
      redBorder: false,
    },
  },
};